module.exports = __webpack_public_path__ + "img/Boxing.1cccddab.png";